import { connectorsListQuery } from 'src/services/DOM/queries/connectorsList/__generated__/connectorsListQuery.graphql';
import { formatSources } from '../formatSources';
import { formatModels } from '../formatModels';
import { buildConnectorStageObject } from '../buildConnectorStageObject';
import { BuildConnectorsListReturn } from './model';
import { ConnectorStages } from 'src/products/connector/constants';

export const buildConnectorsList = (
  connectors: connectorsListQuery['response']['connectors'],
  canAddConnector: boolean
): BuildConnectorsListReturn[] => {
  const connectorsList: BuildConnectorsListReturn[] = [];

  connectors.forEach((connector) => {
    const {
      models,
      displayName,
      name,
      sources,
      statusObject,
      devStatusObject,
      qcStatusObject,
    } = connector;

    const formattedSources = formatSources(sources);

    const formattedModels = formatModels(models);

    const connectorBaseData = {
      displayName: displayName ?? name,
      id: name,
      disabled: false,
      schemaName: '',
      sources: formattedSources,
      models: formattedModels,
    } as any;

    if (statusObject?.status) {
      const { endDatetime, status: connectorStatus, isRunning } = statusObject;

      const {
        lastRun,
        status,
        connectorRunningObject,
        connectorStatusMessage,
        nextRun,
        failedConnectorComponent,
      } = buildConnectorStageObject({
        status: connectorStatus,
        connector,
        endDatetime,
        isRunning,
      });

      const connectorData = {
        ...connectorBaseData,
        failedConnectorComponent,
        connectorRunningObject,
        name: `${name}_publish`,
        lastRun,
        nextRun,
        statusMessage: connectorStatusMessage,
        status,
        stage: ConnectorStages.PUBLISH,
      };

      connectorsList.push(connectorData);
    }

    if (!canAddConnector) {
      return connectorsList;
    }

    if (devStatusObject?.status) {
      const {
        endDatetime,
        status: connectorStatus,
        isRunning,
      } = devStatusObject;

      const {
        lastRun,
        status,
        connectorRunningObject,
        connectorStatusMessage,
        nextRun,
        failedConnectorComponent,
      } = buildConnectorStageObject({
        status: connectorStatus,
        connector,
        endDatetime,
        isRunning,
        stage: ConnectorStages.DEV,
      });

      const connectorData = {
        ...connectorBaseData,
        connectorRunningObject,
        failedConnectorComponent,
        name: `${name}_dev`,
        lastRun,
        nextRun,
        statusMessage: connectorStatusMessage,
        stage: ConnectorStages.DEV,
        status,
      };

      connectorsList.push(connectorData);
    }

    if (qcStatusObject?.status) {
      const {
        endDatetime,
        status: connectorStatus,
        isRunning,
      } = qcStatusObject;

      const {
        lastRun,
        status,
        connectorRunningObject,
        connectorStatusMessage,
        nextRun,
        failedConnectorComponent,
      } = buildConnectorStageObject({
        status: connectorStatus,
        connector,
        endDatetime,
        isRunning,
        stage: ConnectorStages.QC,
      });

      const connectorData = {
        ...connectorBaseData,
        connectorRunningObject,
        failedConnectorComponent,
        lastRun,
        nextRun: nextRun,
        name: `${name}_qc`,
        statusMessage: connectorStatusMessage,
        stage: ConnectorStages.QC,
        status,
      };

      connectorsList.push(connectorData);
    }
  });

  return connectorsList;
};
